import { render } from "./cloudflare-dns-records-all.vue?vue&type=template&id=cefeecd6&scoped=true"
import script from "./cloudflare-dns-records-all.vue?vue&type=script&lang=js"
export * from "./cloudflare-dns-records-all.vue?vue&type=script&lang=js"

import "./cloudflare-dns-records-all.vue?vue&type=style&index=0&id=cefeecd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cefeecd6"]])

export default __exports__